import config from '../config';
import { authFetch } from '../auth/AuthContext';

/** A request that requires a signed-in user, with a transparent token refresh. */
export async function authedJson<T>(
  path: string,
  options: RequestInit,
  getToken: () => string | null,
  doRefresh: () => Promise<boolean>,
): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');

  const res = await authFetch(`${config.apiUrl}${path}`, { ...options, headers }, getToken, doRefresh);
  if (res.status === 204) return undefined as T;

  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message ?? 'Request failed');
  return data as T;
}

/** A request to a public route — no token, no refresh. */
export async function publicJson<T>(path: string): Promise<T> {
  const res = await fetch(`${config.apiUrl}${path}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message ?? 'Request failed');
  return data as T;
}
